import apiClient from '../../../config'
import { downloadKlingResultVideoBlob } from './volc-kling-fetch-video-blob'

var POLL_INTERVAL = 3000
var POLL_TIMEOUT = 10 * 60 * 1000
var CREATE_PATH = 'kling/v3/createVideo'
var RESULT_PATH = 'kling/v3/getTaskResult'

/**
 * 提交 Kling v3 视频生成任务
 */
export function submitKlingV3Task(params) {
  var videoMode = params.videoMode || 'text'
  var duration = params.videoDuration || 5
  var prompt = (params.prompt || '').trim()
  var negativePrompt = (params.negativePrompt || '').trim()
  var generateAudio = !!params.generateAudio
  var aspectRatio = params.aspectRatio || '16:9'
  if (!prompt) return Promise.reject(new Error('prompt 必填'))

  var miToken = typeof localStorage !== 'undefined' ? localStorage.getItem('token') || '' : ''
  var body = {
    prompt: prompt,
    length: duration,
    generateAudio: generateAudio,
    aspectRatio: aspectRatio,
    negativePrompt: negativePrompt || null,
    miToken: miToken
  }

  if (videoMode === 'image' && params.referenceImage) {
    body.image = String(params.referenceImage)
    if (params.endFrameImage) {
      body.imageTail = String(params.endFrameImage)
    }
  }

  return apiClient.post(CREATE_PATH, body).then(function (resp) {
    if (resp.code !== 200) {
      return Promise.reject(new Error(resp.message || 'Kling 提交失败'))
    }
    var taskId = resp.data && resp.data.taskId ? resp.data.taskId : ''
    if (!taskId) return Promise.reject(new Error('Kling 未返回 taskId'))
    return { taskId: String(taskId), videoMode: videoMode }
  })
}

/**
 * 轮询 Kling v3 任务状态
 */
export function pollKlingV3Task(taskId, callback, interval, options) {
  var pollInterval = interval || POLL_INTERVAL
  var deadline = Date.now() + POLL_TIMEOUT
  var pollTimer = null
  var stopped = false

  function stop() { stopped = true; if (pollTimer) { clearTimeout(pollTimer); pollTimer = null } }

  function poll() {
    if (stopped) return
    var miToken = typeof localStorage !== 'undefined' ? localStorage.getItem('token') || '' : ''
    apiClient.post(RESULT_PATH, { taskId: taskId, miToken: miToken }).then(function (resp) {
      if (stopped) return
      if (resp.code !== 200) {
        var errMsg = resp.message || 'Kling 查询失败'
        if (typeof callback === 'function') callback(new Error(errMsg), null)
        stop()
        return
      }
      var data = resp.data || {}
      var status = String(data.status || '').toLowerCase()
      var parsed = { status: 'processing', url: null, error: null }

      if (status === 'succeed') {
        var urlOk = data.videoUrl ? String(data.videoUrl) : ''
        if (!urlOk) {
          if (typeof callback === 'function') callback(null, { status: 'failed', url: null, error: 'Kling 未返回视频 URL' })
          stop()
          return
        }
        downloadKlingResultVideoBlob(urlOk)
          .then(function (blob) {
            if (stopped) return
            if (typeof callback === 'function') callback(null, { status: 'completed', url: urlOk, videoBlob: blob, error: null })
            stop()
          })
          .catch(function () {
            if (stopped) return
            if (typeof callback === 'function') callback(null, { status: 'completed', url: urlOk, videoBlob: null, error: null })
            stop()
          })
        return
      }
      if (status === 'failed') {
        parsed = { status: 'failed', url: null, error: '生成失败' }
      } else {
        parsed = { status: 'processing', url: null, error: null }
      }

      if (typeof callback === 'function') callback(null, parsed)
      if (parsed.status === 'completed' || parsed.status === 'failed') { stop(); return }
      if (Date.now() > deadline) { if (typeof callback === 'function') callback(new Error('轮询超时'), null); stop(); return }
      pollTimer = setTimeout(poll, pollInterval)
    }).catch(function (err) {
      if (stopped) return
      if (typeof callback === 'function') callback(err, null)
      stop()
    })
  }

  poll()
  return { stop: stop }
}
